import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

import { ISequentialBrowseModalProps } from ".";

export const useSequentialBrowseModalStore = createSmartrrModal<ISequentialBrowseModalProps>();
